export default __webpack_public_path__ + "static/media/annealing-icon.80507822.svg";